"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lang_1 = __importDefault(require("../../../lang"));
function email({ isOrganizationEmail } = { isOrganizationEmail: false }) {
    /* eslint-disable */
    return this.matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, (0, lang_1.default)().validation.email(isOrganizationEmail));
    /* eslint-enable */
}
exports.default = email;
